import { SaveCardDescription } from '../../../store/actions';

import * as storymapStoreModule from '../../../store';
import { CardType, ChangeCardDescription } from '..';
import { getCardType } from './use';
import { getCardById } from '../../../store/use';
import { uuid } from '@/_core/utils/uuid';
import { BoardUserActivityType } from '@/api/workspaceSettings/queries';

export const createSaveCardDescriptionCommand = async (action: SaveCardDescription) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = getCardById(action.id);
    const cardType = getCardType(card);

    const cmd = new ChangeCardDescription(action.id, state.id, action.description, CardType[cardType]);
    const activityId = await uuid.create();

    const activity = {
        CardId: card.id,
        CardName: card.title,
        Datetime: new Date().toJSON(),
        CardDescription: action.description,
        EstimationUnit: '',
        OriginalContent: card.description,
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: getActivityType(cardType),
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    cmd.BoardActivity = activity;

    return cmd;
};

const getActivityType = (cardType: CardType) => {
    switch (cardType) {
        case CardType.Activity:
            return BoardUserActivityType.ActivityDescriptionChanged;
        case CardType.Task:
            return BoardUserActivityType.TaskDescriptionChanged;
        case CardType.Subtask:
            return BoardUserActivityType.SubtaskDescriptionChanged;
        case CardType.UnscheduledSubtask:
            return BoardUserActivityType.UnscheduledSubtaskDescriptionChanged;
    }
};
